import { createAction } from "@reduxjs/toolkit";

export const routerPageChange = createAction<string>("routerPageChange");
